import { SpaceBetween } from '@cloudscape-design/components';
import { DripEmail, DripEmailBasic } from '../common/types';
import { DripEmailStatus } from './DripEmailStatus';
import { useMemo } from 'react';

export type DripEmailListProps = {
  emails: DripEmailBasic[];
};

export function DripEmailList(props: DripEmailListProps) {
  const sortedEmails = useMemo(() => {
    const sortedEmails = [...props.emails];
    sortedEmails.sort((a, b) => {
      const aDate = a.scheduled_at ?? a.sent_at ?? a.opened_at ?? a.created_at;
      const bDate = b.scheduled_at ?? b.sent_at ?? b.opened_at ?? b.created_at;
      if (aDate && bDate) {
        return new Date(bDate).getTime() - new Date(aDate).getTime();
      }
      return 0;
    });
    return sortedEmails;
  }, [props.emails]);
  return (
    <SpaceBetween direction="vertical" size="xxxs">
      {sortedEmails.map((email, index) => (
        <SpaceBetween direction="vertical" size="xxxs" key={email.uuid}>
          <DripEmailStatus item={email} />
          {index < sortedEmails.length - 1 && <hr />}
        </SpaceBetween>
      ))}
    </SpaceBetween>
  );
}
